<template>
    <div class="campaign-builder-modal">
        <DsModal
            is-open
            :show-close="isInternal"
            size="lg"
            class="integration-modal"
            data-qa="integration-modal"
            :title="cell.value.name"
            @close="closeModal"
        >
            <template #header>
                <div v-if="iframeUrl">
                    {{ $t('funnel.edit.goal.integration.summary') }}
                </div>
            </template>
            <template #default>
                <iframe v-if="!isInternal" class="external-config-frame" :src="iframeUrl" />

                <template v-else>
                    <div v-if="!integrationComponent">
                        {{ $t('funnel.edit.goal.integration.noConfig') }}: {{ integrationByType && integrationByType.context }}
                    </div>

                    <component
                        :is="integrationComponent"
                        v-else
                        :cell="cell"
                        :oracle-id="oracleId"
                        :flags-info="flagsInfo"
                        @internal-receive-message="receiveMessage"
                        @update-config="updateConfig"
                        @closeModal="closeModal"
                    />
                </template>
            </template>
        </DsModal>
    </div>
</template>

<script>
import uuid from 'uuid/v4';
import IntegrationModals from '../../integrations';

const MESSAGE_TYPES = {
    SAVE: 'save',
    CLOSE: 'close',
    STATUS: 'status',
};

export default {
    props: {
        enabledIntegrations: {
            type: Array,
            default: () => [],
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                },
            }),
        },
        flagsInfo: {
            type: Object,
            default: () => ({}),
        },
    },

    emits: ['close-modal', 'update-cell-value'],

    data() {
        return {
            oracleId: this.cell.value.oracleId || uuid(),
        };
    },

    computed: {
        isInternal() {
            const internalUrlFlag = 'INTERNAL';

            return this.integrationByType?.url === internalUrlFlag;
        },

        integrationComponent() {
            return IntegrationModals[this.integrationByType?.context];
        },

        integrationByType() {
            return this.enabledIntegrations.find((integration) => integration.id === this.cell.value.integrationTriggerId);
        },

        iframeUrl() {
            if (this.isInternal) return null;

            const regex = /^(http|https)/;

            const matches = regex.exec(this.integrationByType?.url);

            if (!matches) return null;

            const url = new URL(this.integrationByType?.url);

            url.searchParams.append('oracleId', this.oracleId);

            return url.toString();
        },
    },

    mounted () {
        window.addEventListener('message', this.receiveMessage);
    },

    beforeUnmount () {
        window.removeEventListener('message', this.receiveMessage);
    },

    methods: {
        receiveMessage (event) {
            const { type } = event.data;

            if (type === MESSAGE_TYPES.CLOSE) {
                this.closeModal();
            } else if (type === MESSAGE_TYPES.SAVE) {
                const { isReady } = event.data;

                this.updateConfig(isReady);
            } else if (type === MESSAGE_TYPES.STATUS) {
                const { isReady } = event.data;

                this.updateReady(isReady);
            }
        },

        closeModal() {
            this.$emit('close-modal');
        },

        async updateConfig(ready) {
            const updatedCell = { ...this.cell };

            updatedCell.value.oracleId = this.oracleId;

            this.$emit('update-cell-value', { cell: updatedCell, isReady: ready });
        },

        async updateReady(ready) {
            const updatedCell = { ...this.cell };

            updatedCell.value.oracleId = this.oracleId;

            this.$emit('update-cell-value', { cell: updatedCell, preventClose: true, isReady: ready });
        },
    },
};
</script>

<style lang="scss" scoped>
.integration-modal {
    padding: 0;
}

.external-config-frame {
    width: 100%;
    height: 75vh;
    border: 0;
}
</style>
